var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossFilledLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E02F2A",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46634 6.91161L7.37795 6.82322L7.28956 6.91161L6.91161 7.28956L6.82322 7.37795L6.91161 7.46634L11.4453 12L6.91161 16.5337L6.82322 16.6221L6.91161 16.7104L7.28956 17.0884L7.37795 17.1768L7.46634 17.0884L12 12.5547L16.5337 17.0884L16.6221 17.1768L16.7104 17.0884L17.0884 16.7104L17.1768 16.6221L17.0884 16.5337L12.5547 12L17.0884 7.46634L17.1768 7.37795L17.0884 7.28956L16.7104 6.91161L16.6221 6.82322L16.5337 6.91161L12 11.4453L7.46634 6.91161Z",
    fill: "#ED1C24",
    stroke: "#ED1C24",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossFilledLight);
export default __webpack_public_path__ + "static/media/cross-filled-light.aa737e7c0cca738532b7c42c2c201b38.svg";
export { ForwardRef as ReactComponent };